import React, { useEffect, useState, useRef, useCallback } from 'react';
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import AsyncCreatableSelect from "react-select/async-creatable";
import { customFetch } from '../apiClient';

const selectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: '26px',
    height: '26px',
    fontSize: '11px',
    borderRadius: '4px',
    borderColor: state.isFocused ? 'var(--theme-color, #0088cc)' : '#cbd5e0',
    boxShadow: state.isFocused ? '0 0 0 2px color-mix(in srgb, var(--theme-color, #0088cc), transparent 85%)' : 'none',
    '&:hover': { borderColor: 'var(--theme-color, #0088cc)' },
    padding: '0'
  }),
  valueContainer: (base) => ({ ...base, padding: '0 6px', height: '24px' }),
  indicatorsContainer: (base) => ({ ...base, height: '24px' }),
  dropdownIndicator: (base) => ({ ...base, padding: '0 4px' }),
  clearIndicator: (base) => ({ ...base, padding: '0 4px' }),
  input: (base) => ({ ...base, margin: '0', padding: '0', fontSize: '11px' }),
  menu: (base) => ({ ...base, zIndex: 99999, borderRadius: '4px' }),
  menuPortal: (base) => ({ ...base, zIndex: 99999 }),
  option: (base, state) => ({
    ...base,
    fontSize: '11px',
    padding: '6px 10px',
    backgroundColor: state.isSelected
      ? 'var(--theme-color, #0088cc)'
      : state.isFocused
        ? 'color-mix(in srgb, var(--theme-color, #0088cc), white 90%)'
        : 'white',
    color: state.isSelected ? 'white' : '#333',
    cursor: 'pointer',
    '&:active': { backgroundColor: 'var(--theme-color, #0088cc)', color: 'white' }
  }),
  placeholder: (base) => ({ ...base, color: '#a0aec0', fontSize: '11px' })
};

const payModeOptions = [
  { value: "Cash", label: "Cash" },
  { value: "UPI", label: "UPI" },
  { value: "Cheque", label: "Cheque" },
  { value: "Other", label: "Other" }
];

const ExPDTForm = () => {
  const [accounts, setAccounts] = useState([]);
  const [banks, setBanks] = useState([]);
  const [doctors, setDoctors] = useState([]);

  // UPDATE 1: patientType aur refId add kiya
  const [formData, setFormData] = useState({
    amID: "",
    bid: "",
    amount: "",
    edate: new Date().toISOString().slice(0, 10),
    payMode: "Cash",
    chqNo: "",
    chqDate: "",
    remarks: "",
    patientName: "",
    doctorName: "",
    patientType: "", 
    refId: null      
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [selectedPatient, setSelectedPatient] = useState(null);

  const formRef = useRef(null);

  useEffect(() => {
    if (success) { const t = setTimeout(() => setSuccess(""), 3000); return () => clearTimeout(t); }
  }, [success]);

  useEffect(() => {
    if (error) { const t = setTimeout(() => setError(""), 4000); return () => clearTimeout(t); }
  }, [error]);
useEffect(() => {
    // Token nikalne ki line hata di gayi hai
    customFetch(`/AccountMaster`)
      .then(res => res.json())
      .then(data => setAccounts(data.map(acc => ({ value: acc.amId, label: acc.name }))))
      .catch(() => setError("Failed to load account master data"));

    customFetch(`/BankDT`)
      .then(res => res.json())
      .then(data => setBanks(data.map(bank => ({ value: bank.bid, label: `${bank.bName} (${bank.acNo})` }))))
      .catch(() => setError("Failed to load bank data"));

    customFetch(`/Employees/doctors`)
      .then(res => res.json())
      .then(data => {
        setDoctors(data.map(d => {
          let labelText = d.name;
          if (d.degree) labelText += ` (${d.degree})`;
          if (d.department?.departmentName) labelText += ` - ${d.department.departmentName}`;
          return { value: labelText, label: labelText };
        }));
      })
      .catch(() => console.error("Failed to load doctors"));
  }, []);

  const loadPatientOptions = async (inputValue) => {
    if (!inputValue) return [];
    try {
     
      const formatDate = (dateString) => {
        if (!dateString) return "N/A";
        const d = new Date(dateString);
        return isNaN(d.getTime()) ? dateString : d.toLocaleDateString('en-IN');
      };

      const ipdPromise = customFetch(`/Ipds/list?search=${encodeURIComponent(inputValue)}`)
        .then(res => res.json())
        .catch(() => []);

      const opdPromise = customFetch(`/Opds/list?search=${encodeURIComponent(inputValue)}&useDateFilter=false`)
        .then(res => res.json())
        .then(data => data.data || [])
        .catch(() => []);
      const [ipdData, opdData] = await Promise.all([ipdPromise, opdPromise]);

      // UPDATE 2: refId add kiya
      const ipdOptions = (Array.isArray(ipdData) ? ipdData : []).map(item => {
        const uhid = item.uhiD_No || item.uhidNo || "N/A";
        const date = formatDate(item.regDate || item.ipD_Date);
        return {
          label: `[IPD] ${item.name} | Date: ${date} | UHID: ${uhid} | Mob: ${item.mobileNo} | IPD No: ${item.ipD_SRNO}`,
          value: item.name,
          originalData: { ...item, type: 'IPD', refId: item.ipD_ID }
        };
      });

      // UPDATE 3: refId add kiya
      const opdOptions = (Array.isArray(opdData) ? opdData : []).map(item => {
        const uhid = item.uhidNo || item.uhiD_No || "N/A";
        const date = formatDate(item.regDate || item.opdDate);
        return {
          label: `[OPD] ${item.name} | Date: ${date} | UHID: ${uhid} | Mob: ${item.mobileNo} | OPD No: ${item.opD_SRNO}`,
          value: item.name,
          originalData: { ...item, type: 'OPD', refId: item.opdId }
        };
      });

      return [...ipdOptions, ...opdOptions];
    } catch { 
      return []; 
    }
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key !== 'Enter') return;
      
      if (e.target.closest('.react-select__menu')) return;

      const focusableSelector = 
        'input:not([disabled]):not([type="hidden"]):not([readonly]), ' +
        'select:not([disabled]), ' +
        'textarea:not([disabled]):not([readonly]), ' +
        'button:not([disabled])';

      const focusableElements = Array.from(
        formRef.current?.querySelectorAll(focusableSelector) || []
      );

      if (focusableElements.length === 0) return;
      
      const currentIndex = focusableElements.indexOf(document.activeElement);

      if (currentIndex === focusableElements.length - 1) {
        e.preventDefault();
        formRef.current?.requestSubmit();
        return;
      }

      if (e.target.tagName === 'TEXTAREA') return; 

      if (currentIndex >= 0) {
        e.preventDefault();
        focusableElements[currentIndex + 1]?.focus();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => {
      const updated = { ...prev, [name]: value };
      if (name === "payMode" && value !== "Cheque") { updated.chqNo = ""; updated.chqDate = ""; }
      return updated;
    });
  };

  const handleSelectChange = (name, selectedOption) => {
    setFormData(prev => ({ ...prev, [name]: selectedOption ? selectedOption.value : "" }));
  };

  // UPDATE 4: handleIpdPatientChange update kiya
  const handleIpdPatientChange = (selectedOption) => {
    setSelectedPatient(selectedOption);
    
    if (selectedOption && selectedOption.originalData) {
      setFormData(prev => ({ 
        ...prev, 
        patientName: selectedOption.value,
        patientType: selectedOption.originalData.type,
        refId: selectedOption.originalData.refId
      }));
    } else if (selectedOption) {
      setFormData(prev => ({ 
        ...prev, 
        patientName: selectedOption.value,
        patientType: "Manual",
        refId: null 
      }));
    } else {
      setFormData(prev => ({ 
        ...prev, 
        patientName: "", 
        patientType: "", 
        refId: null 
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(""); setSuccess("");
    if (!formData.amID || !formData.amount || !formData.edate) { setError("Please fill all required fields."); return; }
    if (formData.payMode === "Cheque" && (!formData.chqNo || !formData.chqDate)) { setError("Cheque number and cheque date are required."); return; }

    setLoading(true);
    // UPDATE 5: payload me patientType aur refId bheja
    const payload = {
      amID: Number(formData.amID),
      bid: formData.bid ? Number(formData.bid) : 0,
      amount: parseFloat(formData.amount),
      ExDate: formData.edate,
      payMode: formData.payMode,
      chqNo: formData.payMode === "Cheque" ? formData.chqNo : null,
      chqdate: formData.payMode === "Cheque" ? formData.chqDate : null,
      remarks: formData.remarks,
      patientName: formData.patientName,
      doctorName: formData.doctorName,
      patientType: formData.patientType, 
      refId: formData.refId ? Number(formData.refId) : null 
    };

    const token = sessionStorage.getItem("token");
   try {
      const res = await customFetch(`/ExPDT`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      if (!res.ok) throw new Error(await res.text() || "Failed to save expense data.");
      setSuccess("Expense saved successfully!");
      // UPDATE 6: Reset karte waqt bhi add kiya
      setFormData({ amID: "", bid: "", amount: "", edate: new Date().toISOString().slice(0, 10), payMode: "Cash", chqNo: "", chqDate: "", remarks: "", patientName: "", doctorName: "", patientType: "", refId: null });
      setSelectedPatient(null);
    } catch (err) { setError(err.message); } finally { setLoading(false); }
  };

  return (
    <div className="dc-wrap">
      <div className="dc-card">
        <div className="dc-header">
          <div className="dc-header-inner">
            <div className="dc-header-brand">
              <div className="dc-header-icon"><i className="bi bi-cash-stack"></i></div>
              <span className="dc-header-title">Expense Entry</span>
            </div>
          </div>
        </div>

        <div className="dc-body">
          {error && <div className="dc-alert dc-alert-danger"><i className="bi bi-exclamation-triangle-fill"></i> {error}</div>}
          {success && <div className="dc-alert dc-alert-success"><i className="bi bi-check-circle-fill"></i> {success}</div>}

          <form ref={formRef} onSubmit={handleSubmit}>
            <div className="dc-section">
              <div className="dc-section-title"><i className="bi bi-info-circle"></i><span>Expense Details</span></div>
              <div className="dc-section-body">

                {/* ROW 1: Expense Type | Patient (OPD/IPD) | Remarks (Doctor) */}
                <div className="dc-grid dc-grid-row1 dc-mb2">
                  <div>
                    <label className="dc-label">Expense Type <span className="dc-required">*</span></label>
                    <Select
                      autoFocus={true}
                      options={accounts}
                      value={accounts.find(opt => opt.value === formData.amID) || null}
                      onChange={(opt) => handleSelectChange('amID', opt)}
                      placeholder="Select Expense Type"
                      styles={selectStyles}
                      isDisabled={loading}
                      menuPortalTarget={document.body}
                      classNamePrefix="react-select"
                    />
                  </div>
                  <div>
                    <label className="dc-label">Patient (OPD/IPD) <span className="dc-required">*</span></label>
                    <AsyncCreatableSelect
                      cacheOptions
                      defaultOptions
                      loadOptions={loadPatientOptions}  
                      onChange={handleIpdPatientChange}
                      placeholder="Search or Type Name..."
                      value={selectedPatient}
                      isClearable
                      isDisabled={loading}
                      styles={selectStyles}
                      menuPortalTarget={document.body}
                      classNamePrefix="react-select"
                    />
                  </div>
                  <div>
                    <label className="dc-label">Remarks (or Search Doctor)</label>
                    <CreatableSelect
                      options={doctors}
                      value={formData.doctorName ? { label: formData.doctorName, value: formData.doctorName } : null}
                      onChange={(opt) => handleSelectChange('doctorName', opt)}
                      placeholder="Search or Type Doctor..."
                      isClearable
                      isDisabled={loading}
                      styles={selectStyles}
                      menuPortalTarget={document.body}
                      classNamePrefix="react-select"
                    />
                  </div>
                </div>

                {/* ROW 2: Expense Date | Bank Account | Amount | Payment Mode */}
                <div className="dc-grid dc-grid-row2 dc-mb2">
                  <div>
                    <label className="dc-label">Expense Date <span className="dc-required">*</span></label>
                    <input name="edate" type="date" className="dc-input" value={formData.edate} onChange={handleChange} required disabled={loading} />
                  </div>
                  <div>
                    <label className="dc-label">Bank Account</label>
                    <Select
                      options={banks}
                      value={banks.find(opt => opt.value === formData.bid) || null}
                      onChange={(opt) => handleSelectChange('bid', opt)}
                      placeholder="Select Bank"
                      styles={selectStyles}
                      isDisabled={loading}
                      menuPortalTarget={document.body}
                      classNamePrefix="react-select"
                    />
                  </div>
                  <div>
                    <label className="dc-label">Amount (₹) <span className="dc-required">*</span></label>
                    <input name="amount" type="number" step="0.01" className="dc-input" placeholder="0.00" value={formData.amount} onChange={handleChange} required disabled={loading} />
                  </div>
                  <div>
                    <label className="dc-label">Payment Mode <span className="dc-required">*</span></label>
                    <Select
                      options={payModeOptions}
                      value={payModeOptions.find(opt => opt.value === formData.payMode) || null}
                      onChange={(opt) => handleSelectChange('payMode', opt)}
                      styles={selectStyles}
                      isDisabled={loading}
                      menuPortalTarget={document.body}
                      classNamePrefix="react-select"
                    />
                  </div>
                </div>

                {/* Cheque fields (only when Cheque selected) */}
                {formData.payMode === "Cheque" && (
                  <div className="dc-grid dc-grid-3 dc-mb2">
                    <div>
                      <label className="dc-label">Cheque No <span className="dc-required">*</span></label>
                      <input name="chqNo" type="text" className="dc-input" placeholder="Cheque No" value={formData.chqNo} onChange={handleChange} required disabled={loading} />
                    </div>
                    <div>
                      <label className="dc-label">Cheque Date <span className="dc-required">*</span></label>
                      <input name="chqDate" type="date" className="dc-input" value={formData.chqDate} onChange={handleChange} required disabled={loading} />
                    </div>
                  </div>
                )}

                {/* Remarks — full width (Commented out as requested) */}
                {/* <div className="dc-grid dc-grid-1">
                  <div>
                    <label className="dc-label">Remarks</label>
                    <textarea name="remarks" className="dc-textarea" placeholder="Additional comments..." value={formData.remarks} onChange={handleChange} rows="2" disabled={loading} />
                  </div>
                </div> */}

              </div>
            </div>

            <div className="dc-form-footer">
              <button type="submit" className="dc-btn-submit" disabled={loading}>
                {loading ? "Saving..." : "Save Expense"}
              </button>
            </div>
          </form>
        </div>
      </div>

      <style jsx>{`
        *, *::before, *::after { box-sizing: border-box; }
        .dc-wrap { padding: 0; font-family: system-ui, sans-serif; }

        .dc-card { background: #fff; border-radius: 6px; box-shadow: 0 1px 8px rgba(0,0,0,0.06); border: 1px solid #e0e6ed; overflow: visible; }

        .dc-header { background: var(--theme-color, #0088cc); padding: 6px 12px; border-radius: 6px 6px 0 0; border-bottom: 2px solid rgba(0,0,0,0.1); }
        .dc-header-inner { display: flex; align-items: center; }
        .dc-header-brand { display: flex; align-items: center; gap: 6px; color: white; font-weight: 600; font-size: 13px; }

        .dc-body { padding: 10px 12px; }

        .dc-section { background: #f8f9fa; border: 1px solid #e0e6ed; border-radius: 5px; margin-bottom: 10px; overflow: visible; }
        .dc-section-title { background: var(--theme-color, #0088cc); padding: 5px 10px; display: flex; align-items: center; gap: 5px; border-radius: 4px 4px 0 0; color: white; font-size: 11px; font-weight: 600; }
        .dc-section-body { padding: 8px 10px; background: #fff; border-radius: 0 0 5px 5px; }

        .dc-grid { display: grid; gap: 8px; align-items: start; }
        
        /* UPDATED GRID CLASSES FOR NEW LAYOUT */
        .dc-grid-row1 { grid-template-columns: 1fr 2fr 2fr; } /* Expense Type | Patient | Doctor */
        .dc-grid-row2 { grid-template-columns: repeat(4, 1fr); } /* Date | Bank | Amount | PayMode */
        .dc-grid-3 { grid-template-columns: repeat(3, 1fr); } /* Cheque Fields */
        .dc-grid-1 { grid-template-columns: 1fr; }

        .dc-mb2 { margin-bottom: 8px; }

        .dc-label { display: block; font-size: 10px; font-weight: 600; color: #2c3e50; margin-bottom: 2px; }
        .dc-required { color: #dc2626; }

        .dc-input, .dc-textarea { width: 100%; height: 26px; min-height: 26px; padding: 2px 6px; border: 1px solid #cbd5e0; border-radius: 4px; font-size: 11px; color: #2c3e50; outline: none; }
        .dc-input:focus, .dc-textarea:focus { border-color: var(--theme-color, #0088cc); box-shadow: 0 0 0 2px rgba(0,136,204,0.15); }
        .dc-textarea { resize: vertical; height: auto; min-height: 40px; padding-top: 4px; }

        .dc-form-footer { margin-top: 6px; padding-top: 8px; border-top: 1px solid #e0e6ed; text-align: right; }
        .dc-btn-submit { height: 26px; padding: 0 14px; background: var(--theme-color, #0088cc); color: white; border: none; border-radius: 4px; font-size: 11px; font-weight: 600; cursor: pointer; transition: opacity 0.2s; }
        .dc-btn-submit:hover:not(:disabled) { opacity: 0.9; }
        .dc-btn-submit:disabled { opacity: 0.6; cursor: not-allowed; }

        .dc-alert { padding: 6px 10px; border-radius: 4px; font-size: 11px; margin-bottom: 10px; display: flex; align-items: center; gap: 6px; }
        .dc-alert-danger { background: #fee2e2; color: #b91c1c; border: 1px solid #fecaca; }
        .dc-alert-success { background: #dcfce7; color: #15803d; border: 1px solid #bbf7d0; }

        /* RESPONSIVE DESIGN PRESERVED */
        @media (max-width: 900px) {
          .dc-grid-row1, .dc-grid-row2 { grid-template-columns: 1fr 1fr; }
        }
        @media (max-width: 600px) {
          .dc-grid-row1, .dc-grid-row2, .dc-grid-3 { grid-template-columns: 1fr; }
        }
      `}</style>
    </div>
  );
};

export default ExPDTForm;